/* eslint-disable */


import React, { useEffect, useState } from "react";





import { Link as RouterLink, useSearchParams, useParams, useNavigate, useLocation } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import {
  Box, Typography, Container,
  Table,
  Card,
  Button,
  Grid,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  CardMedia,
  Chip,
  ToggleButtonGroup,
  ToggleButton,
  Stack,
  Avatar
} from '@mui/material';


import { makeStyles } from '@mui/styles';
import { isoDateFormatInDmyhs } from '../utils/formatTime';

// components
import Page from '../components/Page';
import { useAuth } from "../components/customContextProviders/AuthContext";
import { GetAllOrganinazationUser,DeActiveOrganizationUsers,ReActivateOrganizationUsers } from "../network/Organization";

import AlertDialog from "../components/AlertDialog";
import {AddUserToOrganizationModal} from '../components/_dashboard/soundbox'

import { capitalizeFirstLetter, parseValidationErrorMessage,getTextColorUsingUserRole,getBgColorUsingUserRole } from "../utils/Utilities";
import { DeviceOrderdButtons,OrganizationUsersMoreMenu } from "../components/_dashboard/soundbox";
import { APP_CONSTANTS } from "../URLConstants";


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

const useStyles = makeStyles({

  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '75vh',
    maxHeight: '800px',
    marginRight: "3px",
    width: "100%",
    minWidth: "100%",

  },
  backGroundRed: {
    background: "rgba(195, 10, 10, .1)"
  },
  backGroundWhite: {
    background: 'white'
  }
});




export default function OrganizationUsers() {

  const { sessionUserData } = useAuth()
  const [organizationUsers, setOrganizationUsers] = useState([]);
  const classes = useStyles();
  const location = useLocation();

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  const [showTripDetails, setShowTripDetails] = useState("");
  const [dataShowMode, setDataShowMode] = useState('GRID');
  const [selectedOrganization, setSelectedOrganization] = useState({});
  const [isAddUserToOrganizationModalOpen, setIsAddUserToOrganizationModalOpen] = useState(false)

  const [selectedUser, setSelectedUser] = useState({});


  useEffect(() => {
  
    fetchOrganizationUser(location?.state?.organizationData?.id === undefined ||  location?.state?.organizationData?.id === null ? sessionUserData?.user?.organizationId : location?.state?.organizationData?.id);
    return () => {
    }
  }, []);


  const handleShowDataChangeVal = (event) => {
    setDataShowMode(event?.target?.value)

  }

  function fetchOrganizationUser(organizationId) {
    GetAllOrganinazationUser(1, 200, organizationId).then((res) => {
      setOrganizationUsers(res?.data?.data)
    }).catch((error) => {
      setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error), title: "Failed to fetch users", btnLabel: "OK" });
      setOpenAlertDialog(true)
    })
  }

  const handleOrganizationUserMoreMenuClick = (action, userData) => {
    switch (action) {

      case "reactivate_user": {
        setSelectedUser(userData)
        ReActivateOrganizationUsers("",userData?.id).then((_res)=>{
          fetchOrganizationUser(location?.state?.organizationData?.id === undefined ? sessionUserData?.user?.organizationId : location?.state?.organizationData?.id);
          setAlertDialogMetas({ ...alertDialogMetas, message: `${userData?.name}'s account has been activated`, title: "Account Activated", btnLabel: "OK" });
          setOpenAlertDialog(true)

        }).catch((err)=>{
          setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: "", btnLabel: "OK" });
          setOpenAlertDialog(true)
        })
        break;
      }
    
      case "deactivate_user": {
        setSelectedUser(userData)

        DeActiveOrganizationUsers("",userData?.id).then((_res)=>{
          fetchOrganizationUser(location?.state?.organizationData?.id === undefined ? sessionUserData?.user?.organizationId : location?.state?.organizationData?.id);
          setAlertDialogMetas({ ...alertDialogMetas, message: `${userData?.name}'s account has been de-activated`, title: "Account De-Activated", btnLabel: "OK" });
          setOpenAlertDialog(true)

        }).catch((err)=>{
          setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: "", btnLabel: "OK" });
          setOpenAlertDialog(true)
        })
        break;
      }
      case "update_user":{
        setSelectedUser(userData)
        setSelectedOrganization(location?.state?.organizationData?.id === undefined ? sessionUserData?.user?.organization : location?.state?.organizationData)
        setIsAddUserToOrganizationModalOpen(true)


        break;
      }


      default: {
        return
      }
    }
  }

  function onAddUserToOrganizationModalAction(d) {
    alert(d)
  }



  return (
    <Page title=" Users">
      <Box sx={{ pl: 3 }}>     
        <Stack
          direction={{ xs: 'column', sm:'row', md: 'row' }} 
          alignItems='center' 
        >
          <DeviceOrderdButtons />

          <ToggleButtonGroup
            color="primary"
            value={dataShowMode}
            exclusive
            aria-label="Platform"
            sx={{
              height: "35px",
              ml: "20px",
              mt: 2,
              mb: {xs: 1, sm: 'auto', md: 'auto'}
            }}
            onChange={handleShowDataChangeVal}
          >
            <ToggleButton value="GRID">Grid</ToggleButton>
            <ToggleButton value="LIST">List</ToggleButton>
          </ToggleButtonGroup>

          {/* <Button sx={{ mt: 2,height:'5vh' }} size="small" color="whitebg" variant="contained" onClick={() => setShowTripDetails(index+"show")}>More Details</Button> */}
        </Stack>

</Box>
      <Container maxWidth="false">

        

    

            {
              dataShowMode === 'LIST' ?
              <Card data-testid='list-users' sx={{ height: '75vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                  <TableContainer >
                    <Table sx={{ minWidth: 650 }} aria-label="merchant_table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" sx={{ fontWeight: 800 }}>Name</TableCell>
                          <TableCell align="left" sx={{ fontWeight: 800 }}>Phone</TableCell>
                          <TableCell align="left" sx={{ fontWeight: 800 }}>Email</TableCell>
                          <TableCell align="left" sx={{ fontWeight: 800 }}>Role</TableCell>
                          <TableCell align="left" sx={{ fontWeight: 800 }}>Onboarded Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {organizationUsers.map((user) => (
                          <TableRow
                            key={user?.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >

                            <TableCell component="th" scope="row" align="left">{user?.name}</TableCell>
                            <TableCell align="left">{user?.phone}</TableCell>
                            <TableCell align="left">{user?.email}</TableCell>
                            <TableCell align="left">{capitalizeFirstLetter(user?.role)}</TableCell>
                            <TableCell align="left">{isoDateFormatInDmyhs(user?.createdAt)}</TableCell>
                            {
                            sessionUserData?.user?.role===APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN || sessionUserData?.user?.role===APP_CONSTANTS?.USER_ROLE_ADMIN ?
                            <TableCell> <OrganizationUsersMoreMenu handleUser={user} handleClicks={(e) => handleOrganizationUserMoreMenuClick(e, user)}/>   </TableCell>
                              :
                              null
                            }

                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>

                :
                <Card  sx={{ height: '75vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', p:1 }}>
                <Grid data-testid='grid-users' container spacing={2} sx={{ flexGrow: 1, overflowY: 'auto', mt: 1, ml: 0.2 }}>
  

                  {organizationUsers?.map((row, index) => (
                    <Grid xs={6} sm={6} md={3} mb={1} key={row?.name}>
                      <Card sx={{ maxWidth: '95%', minHeight: 280 }} >

                        <CardMedia
                              sx={{ height: 120, objectFit: 'inherit',opacity:.5 }}
                              height="140"
                              component="img"
                              src={location?.state?.organizationData?.image!==undefined && location?.state?.organizationData?.image!==null ? location?.state?.organizationData?.image:  sessionUserData?.user?.organization?.image}
                              title={capitalizeFirstLetter(row?.name)}

                            />

                            <Box sx={{position:'absolute',top:'30%',right:'5%'}}>
                              <Avatar   sx={{ width: 56, height: 56 }} />
                            </Box>

                        {
                          row?.role !== undefined && row?.role !== null && row?.role !== '' ?
                            <Chip variant="contained" size="small" label={capitalizeFirstLetter(row?.role)} sx={{ fontSize: '12px', fontStyle: 'normal', fontWeight: 600, ml: 1, position: 'absolute', top: '2%', backgroundColor:getBgColorUsingUserRole(row?.role),color:getTextColorUsingUserRole(row?.role) }} />
                            :
                            null
                        }


                        {
                          sessionUserData?.user?.role===APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN || sessionUserData?.user?.role===APP_CONSTANTS?.USER_ROLE_ADMIN ?
                          <OrganizationUsersMoreMenu sx={{ position: 'absolute', top: '1%', right: '0%', fontWeight: 900, color: 'black' }} handleUser={row} handleClicks={(e) => handleOrganizationUserMoreMenuClick(e, row)}/>
                          :
                          null
                        }


                        {
                          showTripDetails === index + "show" ?
                            <Box sx={{
                              p: 2, position: 'absolute', top: '15%', width: '100%', height: '100%', backgroundColor: '#F8FAFB',
                              boxShadow: '0 0 10px rgba(1, 1, 0, 0.5)'
                            }}
                            data-testid='more-details'>
                              <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#171D40' }}>
                                {capitalizeFirstLetter(row?.name)}
                              </Typography>
                              <Typography sx={{ fontSize: 12, fontWeight: 700, lineHeight: '20px', color: '#6F6F6F' }}>
                                Date Created - {isoDateFormatInDmyhs(row?.createdAt)}
                              </Typography>
                              <Typography sx={{ fontSize: 12, fontWeight: 700, lineHeight: '20px', color: '#6F6F6F' }}>
                                Email - {row?.email}
                              </Typography>
                              <Typography sx={{ fontSize: 12, fontWeight: 700, lineHeight: '20px', color: '#6F6F6F' }}>
                                Mobile - {row?.phone}
                              </Typography>


                              <Button size="small" sx={{ mt: 2 }} variant="outlined" onClick={() => setShowTripDetails(index + "hide")}>Less Details</Button>

                            </Box>

                            :
                            <Box data-testid='less-details' sx={{ p: 2 }}>
                              <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#171D40' }}>
                                {capitalizeFirstLetter(row?.name)}
                              </Typography>
                              <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#6F6F6F' }}>
                                Email - {row?.email}
                              </Typography>

                              {
                                row?.deletedAt!==undefined && row?.deletedAt!==null && row?.deletedAt!='' ?
                                <Chip variant="contained" size="small" label="In-Active" sx={{ fontSize: '12px', fontStyle: 'normal', fontWeight: 600, position: 'absolute', top: '45%', right:'3%'}}  color="error" />
                                  :
                                  null

                              }




                              {/* <Stack direction='row' spacing={1}>
                          <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#6F6F6F' }}> Date Created  </Typography>
                          <Typography sx={{ fontSize: 14, fontWeight: 800, color: '#6F6F6F' }}>  {fDate(row?.createdAt)} </Typography>
                          </Stack> */}


                              <Button sx={{ mt: 2, position: 'absolute', bottom: '10px' }} size="small" variant="outlined" onClick={() => setShowTripDetails(index + "show")}>More Details</Button>
                            </Box>

                        }

                      </Card>
                    </Grid>
                  ))}

                </Grid>
                </Card>
            }

      </Container>

      <AddUserToOrganizationModal userData={selectedUser} organizationData={selectedOrganization} opneAssignedModal={isAddUserToOrganizationModalOpen} handleClose={() => setIsAddUserToOrganizationModalOpen(false)} onAction={(d) => onAddUserToOrganizationModalAction(d)} />


      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />

    </Page>
  );
}
